import { Box, Grid, IconButton, Typography } from "@mui/material";


import Footer from "../../components/leaderBoard/Footer";
import SvgToHome from "../../components/icon/SvgToHome.jsx";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { AdminApi } from "../../api/AdminApi";

import { getCurrentDateStr } from "../../helper/StringHelper";

import { getLeaderboardFooterSetting } from "../../helper/EventHelper.js";
import MockData from "../../helper/MockData";
import SchoolLeaderboardDisplay from "../../sections/schooLeaderboard/SchoolLeaderboardDisplay";
import SchoolLeaderboardSlideDisplay from "../../sections/schooLeaderboard/SchoolLeaderboardSlideDisplay";


import { getStoredAccountOrgID } from "../../helper/AccountHelper.js";

const TODAY = getCurrentDateStr(); // new Date().toISOString().split("T")[0];

const yearLeaderboardLink = "/user/yearLeaderboard";

export default function Page({ }) {
    const navigate = useNavigate();

    let [searchParams] = useSearchParams();
    let dateRangeType = searchParams.get("dateRangeType") ? searchParams.get("dateRangeType") : "semester1";
    let year = searchParams.get("year") ? parseInt(searchParams.get("year")) : 2024;
    let mode = searchParams.get("mode") ? searchParams.get("mode") : "student";

    const [leaderboardData, setLeaderboardData] = useState(null);

    let filters = {
        dateRangeType: dateRangeType,
        year: year,
    }

    // let mode = "student";
    let storedOrgID = getStoredAccountOrgID();


    useEffect(() => {
        setLeaderboardData((pre) => leaderboardData);


        // console.debug("SportDisplay useEffect: ", leaderboardData);

        // setnIntervId(
        const interval = setInterval(() => {
            console.log("Auto refresh leaderboard data...");
            refreshLeaderboard();
        }, process.env.REACT_APP_UPDATE_INTERVAL || 2000);

        return () => clearInterval(interval);

        // );
    }, [leaderboardData]);

    const refreshLeaderboard = () => {
        // console.debug("onQueryLeaderboard: ", { mode, filters });
        // // const mode = 'student';
        // setMode(mode);

        let callback = (isSuccess, msg, result) => {
            if (isSuccess) {
                setLeaderboardData(result);
                // alert("Success");
            } else {
                alert("Failed to load leaderboard: " + msg);
            }
            // console.debug("result: isSuccess=", isSuccess,
            //     " msg=", msg, " result=", result);
        }
        // AdminApi.getSchoolLeaderboardCallback(orgID, mode, filters, callback);

        console.log("refresh leaderboard: orgID=", storedOrgID, " mode=", mode, " filters=", filters);  
        AdminApi.getSchoolLeaderboardCallback(storedOrgID, mode, filters, callback);
    }

    useEffect(() => {
        refreshLeaderboard();
        // let data = MockData.getAllSkillLeaderboard();
        // setLeaderboardData(data);
    }, []);




    // const { state } = useLocation();
    // const event = state?.event;

    // console.debug("from State (event): ", event);

    const handleBackHome = (e) => {
        navigate(yearLeaderboardLink);
    };

    // const { eventId } = useParams();
    // let [searchParams] = useSearchParams();
    // Get event id from url

    // const orgType = getStoredAccountOrgType();

    // const [leaderData, setLeaderData] = useState([]);


    const updateLeaderbroad = () => {
        // let date = searchParams.get("date") ? searchParams.get("date") : TODAY;
        // console.log("updateLeaderbroad: ", date, " t=", new Date().toLocaleTimeString());

        // AdminApi.loadEventMonthlyLeaderboardCallback(eventId, date, (data) => {
        //   console.log("loadEventMonthlyLeaderboardCallback: ", data);
        //   setLeaderData(data);
        // });
        return;
    }

    useEffect(() => {
        updateLeaderbroad();
        // let date = searchParams.get("date") ? searchParams.get("date") : TODAY;

        // AdminApi.loadEventOverallLeaderboardCallback(eventId, date, (data) => {
        //   console.log("loadEventOverallLeaderboardCallback: ", data);
        //   setLeaderData(data);
        // });
        // return;
    }, []);

    // Footer Setting 
    let { footerLeft, footerRight, footerCenter } = getLeaderboardFooterSetting(null);



    let sliderSetting = {
        interval: 4000,
    }

    return (
        <Box position={"relative"} overflow="hidden">
            <Box position={"absolute"} left={10} top={10} zIndex={10}>
                <IconButton onClick={() => handleBackHome()}>
                    <SvgToHome />
                </IconButton>
            </Box>

            <Footer
                leftLogo={footerLeft} rightLogo={footerRight} sponsor={footerCenter}
            />


            <Grid container
                direction="row"
                alignItems={"center"} sx={{ backgroundColor: '#000', minHeight: '100vh' }}>
                <Grid item xs={12}>
                    <Box sx={{ textAlign: 'center', pt: 0 }}>
                        {
                            leaderboardData == null &&
                            <Typography variant="body" sx={{ color: '#aaa' }}>Loading...</Typography>
                        }

                        {
                            leaderboardData != null &&
                            <SchoolLeaderboardSlideDisplay
                                leaderboardList={leaderboardData}
                                filters={filters}
                                sliderSetting={sliderSetting}
                            />
                        }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
